  import axios from 'axios';
  import store from '@/store'
  import router from '@/router';

  export default function setup() {
    axios.interceptors.request.use(function (config) {
      const token = localStorage['access-token'];

      const locale = localStorage['locale']
      if(locale){
        config.headers.common['LF-Localization'] = locale;
      } else {
        config.headers.common['LF-Localization'] = 'ru';
      }
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }else {
        config.headers.Authorization = null;
        // console.log(config)
      }

      return config;
    }, function (err) {
      return Promise.reject(err);
    });
  }
  axios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {

    if (!error.response) {
      console.error('----------------------------')
      console.error('**Network/Server error');
      console.error(error.response);
      console.error('----------------------------')

    }

    // all the other error responses
    switch (error.response.status) {
      case 400:
        console.error(error.response.status, error.message);
        break;
      case 401: // authentication error, logout the user
        console.error('----------------------------')
        console.error('**Authentication error');
        console.error('----------------------------')
        store.dispatch('auth/logout')
        break;
      default:
        console.error(error.response.status, error.message);
    }
    return Promise.reject(error);
  });
